import React from "react";
import "./herosection.css";
import "../../landingPage/heroSection/herosection.css";
import HeroContent from "../../hero_content";

function HeroSection() {
  return (
    <div className="bg-about">
      <HeroContent
        title="Who we are."
        para="A non-governmental organization aiming at lifting up 
        the living standards of the children and the youths with a 
        positive and healthy mind."
      />
    </div>
  );
}

export default HeroSection;
